import React, { useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GoEye } from "react-icons/go";
import { RiDeleteBinLine } from "react-icons/ri";
import { toast } from "react-hot-toast";
import { dateFormat } from "../../Context/Functionalty";
import { useDispatch } from "react-redux";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import ConfirmDialog from "./ConfirmDialog";
import bookingApi from "../../api/booking/BookingApi";

function Table({ dashboard, datas }) {
  // console.log({ datas });
  const Head = "text-xs font-semibold px-6 py-2 uppercase ";
  const Text = "px-5 text-sm py-3 leading-6 whitespace-nowrap";
  const badge = "py-1 px-2 rounded-full text-xs font-semibold";

  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [localData, setLocalData] = useState(datas);

  const navigate = useNavigate();

  const deleteHandler = (id) => {
    setSelectedId(id);
    setShowConfirm(true);
  };

  const confirmdelete = async ({ _id }) => {
    setShowConfirm(false);

    console.log({ _id });

    try {
      const { response, err } = await bookingApi.deleteBookingById({ _id });
      if (err) throw err;
      toast.success("Booking deleted successfully");
      setLocalData((prev) => prev.filter((item) => item._id !== _id));
      navigate("/listofbooking");
    } catch (error) {
      toast.error("Failed to cancel booking");
      console.error(error);
    }
  };

  const renderServiceList = (selected) => {
    if (!selected.length) {
      return <p className="text-sm text-gray-400 italic">None selected</p>;
    }

    return selected.map((item, i) => (
      <div key={i} className="flex items-start space-x-2 mb-2 max-w-[200px]">
        <div className="w-5 h-5 bg-yellowlight rounded-md flex items-center justify-center mt-1 shrink-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3 w-3 text-yellowdark"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <div className="max-w-[200px] overflow-hidden">
          <p className="truncate max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap">
            {item.title}
            {item.desc && (
              <span className="text-sm text-gray-400"> ({item.desc})</span>
            )}
          </p>
        </div>
      </div>
    ));
  };

  const formatDateTime = (dateStr) => {
    const date = new Date(dateStr);
    return isNaN(date)
      ? dateStr
      : date.toLocaleString("en-NZ", {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
  };

  const Rows = ({ order }) => {
    console.log({ order });
    const isPast =
      order?.selectedDateTime && new Date(order.selectedDateTime) < new Date();

    return (
      <tr className="text-text">
        <td className={`${Text} text-center`}>
          <div className="inline-flex items-center justify-center gap-2">
            <span>{formatDateTime(order?.createdAt)}</span>
            {new Date(order?.createdAt) >
              new Date(Date.now() - 2 * 60 * 60 * 1000) && (
              <span className="bg-yellow-800 text-yellowlight text-[10px] font-bold px-2 py-0.5 rounded-full shadow">
                NEW
              </span>
            )}
          </div>
        </td>
        <td className={`${Text} text-center max-w-[200px]`}>
          {order?.customer_info?.name}
        </td>
        <td className={`${Text} text-center max-w-[200px]`}>
          {renderServiceList(order?.selectedNailServices)}
        </td>
        <td className={`${Text} text-center max-w-[200px]`}>
          {renderServiceList(order?.selectedBeautyServices)}
        </td>
        <td className={`${Text} text-center`}>
          {order?.booking?.status === "booked" && (
            <span
              className={`${badge} ${
                isPast
                  ? "text-gray-400 bg-gray-800"
                  : "text-green-600 bg-green-100"
              }`}
            >
              {isPast ? "completed" : "booked"}
            </span>
          )}
          {order?.booking?.status === "cancelled" && (
            <span className={`${badge} text-red-500 bg-red-100`}>
              {order?.booking?.status}
            </span>
          )}
        </td>
        <td className={`${Text} text-center`}>
          {order?.bookingtype === "user" && (
            <span className={` text-text`}>{order?.bookingtype}</span>
          )}
          {order?.bookingtype === "walk-in" && (
            <span className={`${badge} text-yellowlight bg-yellow-700`}>
              {order?.bookingtype}
            </span>
          )}
        </td>
        <td className={`${Text} text-center`}>
          {order?.reminder === "no" && <span className={` text-text`}>-</span>}
          {order?.reminder === "yes" && (
            <span className={`${badge} text-yellowlight bg-yellow-700`}>
              sent
            </span>
          )}
        </td>
        <td
          className={`${Text} font-normal text-center truncate max-w-[200px] overflow-hidden`}
        >
          {formatDateTime(order?.selectedDateTime)}
        </td>
        <td className={`${Text} float-right flex gap-2`}>
          <button
            onClick={() => deleteHandler(order?._id)}
            className="border text-red-500 border-red-500 rounded flex-colo w-6 h-6"
          >
            <RiDeleteBinLine />
          </button>

          {showConfirm && (
            <ConfirmDialog
              message="Are you sure you want to delete this booking?"
              onConfirm={() => confirmdelete({ _id: selectedId })}
              onCancel={() => setShowConfirm(false)}
            />
          )}

          <Link
            to={`/booking/preview/${order?._id}`}
            className="border text-subMain border-subMain rounded flex-colo w-6 h-6"
          >
            <GoEye />
          </Link>
        </td>
      </tr>
    );
  };

  // --- PAGINATION LOGIC ---
  const [filters, setFilters] = useState({
    bookDate: "",
    selectedDateTime: "",
    status: "",
    type: "",
    nailService: "",
    beautyService: "",
  });

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
    setCurrentPage(1); // Reset to page 1 when filtering
  };

  // Filtered and sorted data
  const filteredData = useMemo(() => {
    return localData.filter((item) => {
      const bookDateMatch = filters.bookDate
        ? new Date(item.createdAt).toLocaleDateString("en-NZ") ===
          new Date(filters.bookDate).toLocaleDateString("en-NZ")
        : true;

      const selectedDateMatch = filters.selectedDateTime
        ? new Date(item.selectedDateTime).toLocaleDateString("en-NZ") ===
          new Date(filters.selectedDateTime).toLocaleDateString("en-NZ")
        : true;
      const statusMatch = filters.status
        ? item.booking?.status === filters.status
        : true;

      const typeMatch = filters.type ? item.bookingtype === filters.type : true;

      const nailServiceMatch = filters.nailService
        ? item.selectedNailServices?.some((s) =>
            s.title.toLowerCase().includes(filters.nailService.toLowerCase())
          )
        : true;

      const beautyServiceMatch = filters.beautyService
        ? item.selectedBeautyServices?.some((s) =>
            s.title.toLowerCase().includes(filters.beautyService.toLowerCase())
          )
        : true;

      return (
        bookDateMatch &&
        selectedDateMatch &&
        statusMatch &&
        typeMatch &&
        nailServiceMatch &&
        beautyServiceMatch
      );
    });
  }, [localData, filters]);

  const sortedData = [...filteredData].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );
  // --- SORTING: Move upcoming bookings to the top ---

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const totalPages = Math.ceil((sortedData.length || 0) / itemsPerPage);
  const currentData = sortedData.slice(startIndex, startIndex + itemsPerPage);

  // const currentData = sortedData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  return (
    <div className="w-full relative overflow-hidden">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 mb-4 w-full">
        <div className="flex flex-col text-sm text-textGray w-full">
          <label htmlFor="book-date" className="mb-1">
            Book Date
          </label>
          <input
            id="book-date"
            type="date"
            value={filters.bookDate}
            onChange={(e) => handleFilterChange("bookDate", e.target.value)}
            className="p-2 rounded bg-textGray text-text border border-border w-full"
          />
        </div>

        <div className="flex flex-col text-sm text-textGray w-full">
          <label htmlFor="selected-date" className="mb-1">
            Appointment Date
          </label>
          <input
            id="selected-date"
            type="date"
            value={filters.selectedDateTime}
            onChange={(e) =>
              handleFilterChange("selectedDateTime", e.target.value)
            }
            className="p-2 rounded bg-textGray text-white border border-border w-full"
          />
        </div>

        <div className="flex flex-col text-sm text-textGray w-full">
          <label htmlFor="status" className="mb-1">
            Status
          </label>
          <select
            id="status"
            value={filters.status}
            onChange={(e) => handleFilterChange("status", e.target.value)}
            className="p-2 rounded bg-textGray text-white border border-border w-full"
          >
            <option value="">All Status</option>
            <option value="booked">Booked</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <div className="flex flex-col text-sm text-textGray w-full">
          <label htmlFor="type" className="mb-1">
            Booking Type
          </label>
          <select
            id="type"
            value={filters.type}
            onChange={(e) => handleFilterChange("type", e.target.value)}
            className="p-2 rounded bg-textGray text-white border border-border w-full"
          >
            <option value="">All Types</option>
            <option value="user">User</option>
            <option value="walk-in">Walk-in</option>
          </select>
        </div>

        <div className="flex flex-col text-sm text-textGray w-full">
          <label htmlFor="nail-keyword" className="mb-1">
            Nail Service
          </label>
          <input
            id="nail-keyword"
            type="text"
            placeholder="🔍 Search..."
            value={filters.nailService}
            onChange={(e) => handleFilterChange("nailService", e.target.value)}
            className="p-2 rounded bg-textGray text-textGray border border-border w-full placeholder:text-gray-400"
          />
        </div>

        <div className="flex flex-col text-sm text-textGray w-full">
          <label htmlFor="beauty-keyword" className="mb-1">
            Beauty Service
          </label>
          <input
            id="beauty-keyword"
            type="text"
            placeholder="🔍 Search..."
            value={filters.beautyService}
            onChange={(e) =>
              handleFilterChange("beautyService", e.target.value)
            }
            className="p-2 rounded bg-textGray text-textGray border border-border w-full"
          />
        </div>
      </div>

      <div className="overflow-x-scroll">
        <table className="table-auto min-w-full border border-neutral-400 divide-y divide-gray-400">
          <thead>
            <tr className=" text-subMain">
              <th className={`${Head} text-center`}>Book Date</th>
              <th className={`${Head} text-center`}>Customer</th>
              <th className={`${Head} text-center`}>Nail Services</th>
              <th className={`${Head} text-center`}>Beauty Services</th>
              <th className={`${Head} text-center`}>Status</th>
              <th className={`${Head} text-center`}>Type</th>
              <th className={`${Head} text-center`}>Reminder</th>

              <th className={`${Head} text-center`}>Date/Time</th>
              <th className={`${Head} text-end`}>Action</th>
            </tr>
          </thead>
          <tbody className="bg-black divide-y divide-neutral-500">
            {currentData?.map((order) => (
              <Rows key={order?._id} order={order} />
            ))}
          </tbody>
        </table>
      </div>

      {/* PAGINATION BUTTONS */}
      <div className="flex justify-center mt-4 space-x-1 items-center">
        {/* Prev Arrow */}
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="p-2 text-white disabled:opacity-30 hover:text-yellow-400 transition"
        >
          <MdKeyboardArrowLeft size={24} />
        </button>

        {/* Page Numbers */}
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => handlePageChange(i + 1)}
            className={`px-3 py-1 text-sm rounded-full font-semibold ${
              currentPage === i + 1
                ? "bg-yellow-500 text-white"
                : "text-white hover:bg-neutral-800"
            }`}
          >
            {i + 1}
          </button>
        ))}

        {/* Next Arrow */}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="p-2 text-white disabled:opacity-30 hover:text-yellow-400 transition"
        >
          <MdKeyboardArrowRight size={24} />
        </button>
      </div>
    </div>
  );
}

export default Table;
